import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomerServiceTemplateComponent from './CustomerServiceTemplateComponent';
import AddBrandToUrl from './utils/AddBrandToUrl';

class CustomerServiceTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSmiley: '',
    };

    this.handleOnClickSmiley = this.handleOnClickSmiley.bind(this);
  }

  handleOnClickSmiley(event) {
    const { smileyId } = event.currentTarget.dataset;

    this.setState({
      selectedSmiley: smileyId,
    });
  }

  render() {
    const { content, airlineWhitelabel, faq, language, brandName } = this.props;
    const { selectedSmiley } = this.state;

    const faqMapped = faq
      .filter(
        ({ url }) =>
          (airlineWhitelabel && url.indexOf(`brand=${airlineWhitelabel.brand}`) !== -1) || url.indexOf('brand=') === -1
      )
      .map(({ url, text }) => ({
        slug: AddBrandToUrl(url, brandName),
        title: text,
        target: '_blank',
      }));

    return (
      <CustomerServiceTemplateComponent
        selectedSmiley={selectedSmiley}
        content={content}
        faq={faqMapped}
        language={language}
        airlineWhitelabel={airlineWhitelabel}
        onClickSmiley={this.handleOnClickSmiley}
        brandName={brandName}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    airlineWhitelabel: state.settings.value.airlineWhitelabel,
    faq: state.settings.value.faq,
    language: state.settings.value.locale.language,
    brandName: (state.settings.value.customSettings && state.settings.value.customSettings.zendeskBrand) || 'tx',
  };
}

export default connect(mapStateToProps)(CustomerServiceTemplate);
